import React, {useState} from "react";
import {
    IonButton,
    IonButtons,
    IonContent,
    IonHeader,
    IonIcon,
    IonMenuButton,
    IonPage,
    IonTitle, IonToast,
    IonToolbar
} from "@ionic/react";
import {arrowBack, menu} from "ionicons/icons";
import ChangeAccount from "./ChangeAccount";


const ChangeAccountPage = ({currentUser, back=false}) => {

    const [showToast, setShowToast] = useState(false);
    const [toastMessage, setToastMessage] = useState("");

    return (
        <IonPage>
            <IonHeader>
                <IonToolbar>
                    <>
                        {back &&
                        <IonButtons slot="start">
                            <IonButton slot={'start'} color={'primary'} onClick={() => back()}>
                                <IonIcon icon={arrowBack}/> Zpět
                            </IonButton>
                        </IonButtons>
                        }
                        <IonTitle>
                            Uživatelské konto
                        </IonTitle>
                    </>
                    <IonButtons slot="end">
                        <IonMenuButton><IonIcon icon={menu}/></IonMenuButton>
                    </IonButtons>
                </IonToolbar>
            </IonHeader>
            <IonContent>
                <ChangeAccount entity={currentUser} setShowToast={setShowToast} setToastMessage={setToastMessage} />
                {showToast &&
                <IonToast
                    isOpen={showToast}
                    onDidDismiss={() => setShowToast(false) }
                    message={toastMessage}
                    duration={5000}
                />
                }

            </IonContent>
        </IonPage>
    );
}

export default ChangeAccountPage;